import React, { ReactElement } from 'react';
import '../style.scss';
// import './style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { Caption } from 'views/mutual/caption';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { useSelectGeneralInvestor } from './hooks';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { TemplateProps } from '../common';

type SelectGeneralInvestorProps = {
  isLinkClicked : boolean,
  setIsLinkClicked : any,
  setMigrationPreference : (ismigrationPreference : boolean) => void
};

export const SelectGeneralInvestorWrapper = () => {
  return <SelectGeneralInvestor {...useSelectGeneralInvestor({ isUpdate: false })}/>;
};

export const SelectGeneralInvestor = ({
  isLinkClicked,
  setIsLinkClicked,
  setMigrationPreference,
  isUpdate,
}: SelectGeneralInvestorProps & TemplateProps) => {
  useCustomLocationName('口座開設');
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();
  return (
    <>
    {!isUpdate && <Caption label="一般投資家への移行" />}
      {!isUpdate && (
        <div className="accountOpenTemplate">
          <FormContentHeader label={
              <div>
              貴社は、一般投資家に移行できる特定投資家です。以下のいずれの取り扱いを希望しますか。
              <br/>
              （特定投資家制度については　
              <a href={process.env.REACT_APP_ABOUT_INVESTOR_URL} style={{ color: '#4f79e7' }} onClick={() => {
                setIsLinkClicked(true)
                }} target="_blank"rel="noopener noreferrer">こちら</a>              
              　をご確認いただいた後でご希望の有無をご選択ください）
              </div>
            }
            formType={FormType.Required} />
            <div className="accountOpenTemplate_button-container">
              <Button
                label={isUpdate ? '登録情報の変更' : '一般投資家への移行を希望する'}
                buttonFill={ButtonFill.black}
                buttonSize={ButtonSize.small}
                disable={!isLinkClicked}
                onClick={() => setMigrationPreference(true)}
              />
              <Button
                label={isUpdate ? '登録情報の変更' : '一般投資家への移行を希望しない'}
                buttonFill={ButtonFill.black}
                buttonSize={ButtonSize.small}
                disable={!isLinkClicked}   
                onClick={() => setMigrationPreference(false)}
              />
            </div>
          
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.investorCategoryInfo)}
          />
        </div>
      )}
    </>
  );
};
